"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Radio = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Check2 = _interopRequireDefault(require("../Check"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Ink = _interopRequireDefault(require("../Ink"));

var _prepareInputName = _interopRequireDefault(require("../_utils/prepareInputName"));

var _check = require("../Check/check");

require("./radio.sass");

var _ref = _react.default.createElement("span", {
  className: "radio-box-outer"
});

var _ref2 = _react.default.createElement("span", {
  className: "radio-box-inner"
});

var Radio =
/*#__PURE__*/
function (_Check) {
  (0, _inherits2.default)(Radio, _Check);

  function Radio() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Radio);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Radio)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "globalListening", function (e) {
      var target = e.target;
      var isLabel = target.parentNode == _this.labelElement || target == _this.labelElement;
      var isRadioBox = target.parentNode.classList.contains('radio-box');

      if (!isLabel && !isRadioBox) {
        _this.setState({
          isFocus: false
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "labelElement", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "ref", function (el) {
      return _this.labelElement = el;
    });
    return _this;
  }

  (0, _createClass2.default)(Radio, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.globalListening);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.globalListening);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          greyscale = _this$props.greyscale,
          className = _this$props.className,
          indeterminate = _this$props.indeterminate,
          noInk = _this$props.noInk,
          checked = _this$props.checked,
          name = _this$props.name,
          parrentRef = _this$props.parrentRef,
          inputProps = (0, _objectWithoutProperties2.default)(_this$props, ["children", "greyscale", "className", "indeterminate", "noInk", "checked", "name", "parrentRef"]);
      var labelProps = {
        className: (0, _classnames.default)('radio', {
          'radio--disabled': inputProps.disabled
        }, className)
      };

      if (checked != null) {
        inputProps.checked = checked;

        inputProps.ref = function (el) {
          if (el) {
            el.indeterminate = !checked && indeterminate;
            parrentRef && parrentRef(el);
          }
        };
      } else if (parrentRef) {
        inputProps.ref = function (el) {
          parrentRef && parrentRef(el);
        };
      }

      _check.mouseEvents.forEach(function (eventName) {
        if (inputProps[eventName]) {
          labelProps[eventName] = inputProps[eventName];
          delete inputProps[eventName];
        }
      });

      return _react.default.createElement("label", (0, _extends2.default)({}, labelProps, {
        ref: this.ref
      }), _react.default.createElement("input", (0, _extends2.default)({
        type: "radio",
        className: "radio-input",
        name: (0, _prepareInputName.default)(name),
        onFocus: this.onFocus,
        onBlur: this.onBlur
      }, inputProps)), _react.default.createElement("span", {
        className: (0, _classnames.default)('radio-box', {
          'radio-box--greyscale': greyscale
        })
      }, _ref, _ref2, inputProps.disabled || inputProps.readOnly || noInk ? null : _react.default.createElement(_Ink.default, {
        primary: true,
        focused: this.state.isFocus
      })), children && _react.default.createElement("span", {
        className: "radio-label"
      }, children));
    }
  }]);
  return Radio;
}(_Check2.default);

exports.Radio = Radio;
var _default = Radio;
exports.default = _default;